import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    PriceLegend,
    PriceLegendItem,
    PriceLegendWrapper,
    InPlayRedirect,
    InPlayRedirectWrapper,
} from './PriceChangeLegend.style';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { useCommon } from 'src/domains/common/Common';
import { EnvironmentState } from 'src/domains/layouts/state/environmentState/EnvironmentState';
import { useAppStateContext } from 'src/appState/AppState';
import { LockIcon } from 'src/ui/assets/icons/other/LockIcon';

interface PropsType {
    isRace: boolean;
}

export const PriceChangeLegend = observer('PriceChangeLegend', ({ isRace }: PropsType): React.ReactElement | null => {
    const common = useCommon();
    const {
        languagesState: { getTranslation },
        unifiedComponentConfig,
    } = useAppStateContext();
    const environmentState = EnvironmentState.get(common);
    const theme = environmentState.emotionTheme;

    const {
        componentVariants: { sportsbookVariant },
        hasInPlayDelayInformation,
        unifiedSportEventsTable,
    } = unifiedComponentConfig;

    const PRICE_LEGEND_LIST = [
        {
            label: getTranslation('special-box.legend.selected', 'Selected'),
            type: 'betslip',
            color: (unifiedSportEventsTable ? theme.star.unified : theme.star).priceLegendList.statusFirst,
        },
        {
            label: getTranslation('special-box.legend.price-going-out', 'Price going out (Drifting)'),
            type: 'drifting',
            color: (unifiedSportEventsTable ? theme.star.unified : theme.star).priceLegendList.statusSecond,
        },
        {
            label: getTranslation('special-box.legend.price-coming-in', 'Price coming in (Shortening)'),
            type: 'shortening',
            color: (unifiedSportEventsTable ? theme.star.unified : theme.star).priceLegendList.statusThird,
        },
        {
            label: getTranslation('special-box.legend.suspended', 'Suspended'),
            type: 'suspended',
            color: (unifiedSportEventsTable ? theme.star.unified : theme.star).priceLegendList.statusFourth,
        },
    ];

    return (
        <PriceLegendWrapper variant={sportsbookVariant}>
            <PriceLegend variant={sportsbookVariant}>
                {PRICE_LEGEND_LIST.map((listItem) => {
                    return (
                        <PriceLegendItem
                            variant={sportsbookVariant}
                            itemColor={listItem.color}
                            type={listItem.type}
                            key={listItem.type}
                        >
                            {unifiedSportEventsTable && listItem.type === 'suspended' ? (
                                <LockIcon className='suspended--icon' />
                            ) : null}
                            {listItem.label}
                        </PriceLegendItem>
                    );
                })}
            </PriceLegend>
            {hasInPlayDelayInformation && isRace === false ? (
                <InPlayRedirectWrapper variant={sportsbookVariant}>
                    <I18n
                        langKey='events.in-play-delay-information'
                        defaultText='In-play information may be subject to delay.'
                    />
                    <InPlayRedirect to={{ account: 'static', static: 'in-play' }}>
                        {unifiedSportEventsTable ? (
                            <I18n
                                langKey='events.in-play-delay-information.button.learn-more'
                                defaultText='Learn More'
                            />
                        ) : (
                            <I18n
                                langKey='events.in-play-delay-information.button.more'
                                defaultText='More'
                            />
                        )}
                    </InPlayRedirect>
                </InPlayRedirectWrapper>
            ) : null}
        </PriceLegendWrapper>
    );
});
